import { render, staticRenderFns } from "./ShipmentCustomFieldsList.vue?vue&type=template&id=744c1233&scoped=true&"
import script from "./ShipmentCustomFieldsList.vue?vue&type=script&lang=js&"
export * from "./ShipmentCustomFieldsList.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentCustomFieldsList.vue?vue&type=style&index=0&id=744c1233&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744c1233",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744c1233')) {
      api.createRecord('744c1233', component.options)
    } else {
      api.reload('744c1233', component.options)
    }
    module.hot.accept("./ShipmentCustomFieldsList.vue?vue&type=template&id=744c1233&scoped=true&", function () {
      api.rerender('744c1233', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BookingFields/components/ShipmentCustomFieldsList.vue"
export default component.exports